export const priceRanges = [
    {min: 0, max: 699, label: "R0 - R699"},
    {min: 700, max: 999, label: "R700 - R999"},
    {min: 1000, max: 99999, label: "R1000+"},
    ]